var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ul',{staticClass:"article-tags list"},_vm._l((_vm.items),function(tag,tagIndex){return _c('li',{key:tagIndex,staticClass:"article-tags__item"},[_c('LinkHandler',{attrs:{"href":_vm.getTagUrl(tag),"target":"_blank"}},[_vm._v(_vm._s(tag.name))])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }